export { default } from "../src/pages/privacy";
